import { useTranslation } from "react-i18next";
import { ClipboardList, FileCheck2, LayoutDashboard, LineChart,
         Settings, Truck, Boxes, Receipt } from "lucide-react";
import { ModuleTabs } from "../../components/data/ModuleTabs";

const TABS = [
  { to: "/purchases", key: "dashboard", icon: LayoutDashboard, end: true, tone: "sky" },
  { to: "/purchases/suppliers", key: "suppliers", icon: Truck, tone: "emerald" },
  { to: "/purchases/requisitions", key: "requisitions", icon: ClipboardList, tone: "amber" },
  { to: "/purchases/orders", key: "orders", icon: FileCheck2, tone: "violet" },
  { to: "/purchases/bills", key: "bills", icon: Receipt, tone: "rose" },
  { to: "/purchases/items", key: "items", icon: Boxes, tone: "indigo" },
  { to: "/purchases/reports", key: "reports", icon: LineChart, tone: "lime" },
  { to: "/purchases/settings", key: "settings", icon: Settings, tone: "cyan" },
];

// تبويبات قسم المشتريات بأسلوب شريط أفقي بخط سفلي للنشط.
export const PurchaseNav = () => {
  const { t } = useTranslation();
  return (
    <ModuleTabs
      testid="purchase-nav"
      tabs={TABS.map((tab) => ({ ...tab, label: t(`purchases.tabs.${tab.key}`) }))}
    />
  );
};
